import { Template } from '@bynder-studio/render-core';
import { gatewayClient, createService } from './connectors/httpClient';

export enum RequestTypes {
    ANALYSIS = 'ANALYSIS',
    IMPORT = 'IMPORT',
}

type CreateTemplateBaseData = {
    type: RequestTypes;
    customerId: number;
    collectionId: string;
    creatorId: string;
    multiDesignMode: boolean;
};

type CreateTemplateGlobalData = CreateTemplateBaseData & {
    mediaId: string;
};

type CreateTemplateLocalData = CreateTemplateBaseData & {
    fileUrl: string;
    storagePath: string;
};

type CreateTemplateFigmaData = CreateTemplateBaseData & {
    figmaImportPropertiesDto: {
        fileKey: string;
        frameIds: string[];
    };
};

export type CreateTemplateData = CreateTemplateGlobalData | CreateTemplateLocalData | CreateTemplateFigmaData;

const httpClient = gatewayClient('/design-creation-requests');

const templatesServiceFromDesignFile = createService(httpClient, (client) => ({
    createTemplate(data: CreateTemplateData) {
        return client.post<Template>('', data);
    },
}));

export default templatesServiceFromDesignFile;
